module Meevo.Plugins.MarketPricing {

    class MeevoServicesViewComponent implements angular.IComponentController {
        static $inject = ['$scope'];

        public model: any;

        constructor(private $scope: angular.IScope) {
            
        }

        $onInit() {
            
        }

        public initData(): void {
            
        }

    }


    angular.module('meevo.plugins.marketPricing')
        .component('meevoServicesViewComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/marketPricing/components/servicesView/servicesView.component.html',
            controller: MeevoServicesViewComponent,
            controllerAs: '$ctrl',
            bindings: {
                model: '<'
            }
        });

}